import { Address} from './address';
import { Gender } from './gender';
import moment from 'moment';

export interface ContactDetails {
    firstName?: string;
    middleName?: string;
    initials?: string;
    lastName?: string;
    dateOfBirth?: moment.Moment;
    gender?: Gender;
    email?: string;
    phoneNumber?: string;
    address?: Address;
}

export function onDeserializeContactDetails(data: ContactDetails): ContactDetails {
    if (data == null) {
        return data;
    }

    if (data.dateOfBirth != null) {
        data.dateOfBirth = moment(data.dateOfBirth);
    }

    return data;
}

export function onSerializeContactDetails(data: ContactDetails): ContactDetails {
    if (data == null) {
        return data;
    }

    const serialized = { ...data };

    serialized.dateOfBirth = data.dateOfBirth?.format('YYYY-MM-DD') as unknown as moment.Moment;

    return serialized;
}
